import { Button, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutLateRouteStatusList } from "./autogen/AutogenLayoutLateRouteStatusList";
import { StringUtil } from "@mcleod/core";

export class LateRouteStatusList extends AutogenLayoutLateRouteStatusList {

    tableLateRouteStatusCodesOnRowDisplay(event: TableRowDisplayEvent) {
        const buttonPlanningScreenColor: Button = event.target.findComponentById("buttonPlanningScreenColor") as Button;
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const color = modelRow.get("late_route_status_color");
        if (!StringUtil.isEmptyString(color)) {
            buttonPlanningScreenColor.color = color;
            buttonPlanningScreenColor.visible = true;
        }
        else {
            buttonPlanningScreenColor.visible = false;
        }
    }

}
